import { SkeletonCircleComponent, SkeletonLinesComponent } from "@iventis/components";
import React from "react";
import { StyledFooter } from "./comment";
import { SkeletonUser } from "./comment-skeleton";

export const SkeletonListComment = () => (
    <div>
        <SkeletonUser>
            <SkeletonCircleComponent width="40px" />
            <SkeletonLinesComponent width="150px" height="15px" />
        </SkeletonUser>
        <SkeletonLinesComponent width="200px" height="15px" />
        <StyledFooter className="comment-footer">
            <SkeletonLinesComponent width="100px" height="15px" />
        </StyledFooter>
    </div>
);
